













import Vue from 'vue'
import SimpleLoader from '@/components/atoms/SimpleLoader.vue'
import DetailCard from '@/components/molecules/DetailCard.vue'
import UseButton from '@/components/molecules/UseButton.vue'
import ConfirmModal from '@/components/organisms/ConfirmModal.vue'
import { State as benefitsState } from '@/store/modules/benefits'

export default Vue.extend({
  name: 'TradeItem',
  components: {
    SimpleLoader,
    DetailCard,
    UseButton,
    ConfirmModal
  },
  data() {
    return {
      isModalShown: false
    }
  },
  computed: {
    isPageLoading(): boolean {
      return this.$state.benefits.isBenefitsLoading || this.$state.home.isHomeLoading || this.$state.tickets.isTicketsLoading
    },
    benefit(): benefitsState['benefitDetil'] | null {
      return this.$state.benefits.benefitDetil
    },
    unuseable(): boolean {
      const myPoint = this.$state.home.home.wallet ? this.$state.home.home.wallet.balances : 0
      return myPoint < (this.benefit ? this.benefit.amount : 0)
    },
    pointText(): string {
      const myPoint = this.$state.home.home.wallet ? this.$state.home.home.wallet.balances : 0
      return `${myPoint}pt→${myPoint - (this.benefit ? this.benefit.amount : 0)}ptになります`
    }
  },
  methods: {
    onModalShow() {
      this.isModalShown = true
    },
    onModalHidden() {
      this.isModalShown = false
    },
    async execPostTickets() {
      await this.$store.dispatch('tickets/postTickets', {
        benefit: this.benefit && this.benefit.id
      })
      this.isModalShown = false
    }
  },
  mounted() {
    if (!this.$state.home.home.token) {
      this.$store.dispatch('home/fetchHome', {})
    }
    this.$store.dispatch('benefits/fetchBenefitDetail', { benefit_id: this.$route.params.id })
  }
})
